import { HttpErrorResponse } from '@angular/common/http';

const GENERIC_MESSAGE =
    'Has superado el número de intentos permitidos. Espera unos momentos e intenta de nuevo.';

/**
 * Texto del 429 para el usuario.
 *
 * El backend manda `{ message }` en el envelope de siempre, pero el `limit_req` de
 * nginx también responde 429 y lo hace con una página HTML: ahí solo queda el
 * header `Retry-After`, y a veces ni eso.
 */
export function rateLimitMessage(error: HttpErrorResponse): string {
    const backendMessage = error.error?.message;
    if (typeof backendMessage === 'string' && backendMessage.trim()) {
        return backendMessage;
    }

    const retryAfter = Number(error.headers?.get('Retry-After'));
    if (retryAfter > 0) {
        return `Has superado el número de intentos permitidos. Espera ${formatWait(
            retryAfter
        )} e intenta de nuevo.`;
    }

    return GENERIC_MESSAGE;
}

function formatWait(seconds: number): string {
    if (seconds < 60) {
        return `${seconds} segundo${seconds === 1 ? '' : 's'}`;
    }
    const minutes = Math.ceil(seconds / 60);
    return `${minutes} minuto${minutes === 1 ? '' : 's'}`;
}
